export default {
  resolveWidth() {
    return window.innerWidth
  },
  popupParams(w, h) {
    let dualScreenLeft = typeof window.screenLeft !== 'undefined' ? window.screenLeft : screen.left
    let dualScreenTop = typeof window.screenTop !== 'undefined' ? window.screenTop : screen.top

    let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
    let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height

    let left = ((width / 2) - (w / 2)) + dualScreenLeft
    let top = ((height / 2) - (h / 2)) + dualScreenTop

    return 'width = ' + w + ', height = ' + h + ', top=' + top + ', left=' + left
  }
}
